import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {connect} from 'react-redux';
import arrow from './images/arrow.svg';

const BackButton = (props) => {

  if(props.page === 'errorPage' || props.page === 'successPage'){
    return null;
  }


  const handleOnLinkClick = () => {
    window.history.back();
  };


  return (
    <div className='wrapper-back-button'>
      <button onClick={handleOnLinkClick}>
        {' '}
        <Image src={arrow} alt='icon' /> חזרה{' '}
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
    page: state.energyReplaceBlock.page,

});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BackButton);
